module.exports = __webpack_public_path__ + "static/media/SarahSwitek_01_Introduction_8.557451d1.mp3";